import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {VacationDetail} from "./vacation-detail";

const VacationDetailPage = React.memo(() => {

    const {id, vacation} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/user/' + id + '/vacations');
    }

    return (
        <VacationDetail id={id} vacation={vacation} onClose={onClose}/>
    )

});

export default VacationDetailPage;